import React, { createContext, useContext, useState } from 'react';
import { useValueRef } from '../../../../hooks/useValueRef';

const Context = createContext();

export const useEvents = () => useContext(Context);

export const EventsProvider = ({
  getCommentAttachment,
  onEditComment,
  onAddComment,
  onDeleteComment,
  getWorkerName,
  children,
}) => {
  const eventsRef = useValueRef({
    getCommentAttachment,
    onEditComment,
    onAddComment,
    onDeleteComment,
    getWorkerName,
  });

  const [events] = useState(() => {
    return eventsRef.current;
  });

  return <Context.Provider value={events}>{children}</Context.Provider>;
};
